import { useEffect, useState } from "react";
import PageShell from "@/components/PageShell";
import api from "@/lib/api";
import { Gift, Copy, Users, Check } from "lucide-react";
import { toast } from "sonner";

export default function Referrals() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/referrals/me").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const copy = async () => {
    try { await navigator.clipboard.writeText(data.share_url); toast.success("Share link copied"); }
    catch { toast.error("Copy failed"); }
  };

  return (
    <PageShell>
      <div className="max-w-3xl mx-auto px-6 py-14">
        <div className="flex items-center gap-3 mb-2">
          <Gift className="w-7 h-7 text-primary" />
          <h1 className="font-serif text-5xl">Give a month, get a month</h1>
        </div>
        <p className="text-muted-foreground max-w-2xl mb-10">
          Share your personal link. When a friend subscribes, you earn a <span className="text-primary">free month</span> —
          credited automatically to your next bill.
        </p>

        {data && (
          <>
            <div className="border border-border bg-card p-8 mb-8">
              <label className="block text-xs uppercase tracking-widest font-mono text-muted-foreground mb-2">Your share link</label>
              <div className="flex gap-3">
                <input readOnly value={data.share_url} data-testid="referral-link"
                  className="flex-1 bg-muted border border-input px-3 py-2.5 rounded-sm text-sm font-mono outline-none" />
                <button onClick={copy} data-testid="referral-copy"
                  className="bg-primary text-primary-foreground px-4 rounded-sm flex items-center gap-2 hover:-translate-y-[1px] transition-transform">
                  <Copy className="w-4 h-4" /> Copy
                </button>
              </div>
              <p className="text-xs text-muted-foreground mt-3 font-mono">Referral code: {data.code}</p>
            </div>

            <div className="grid grid-cols-2 gap-px bg-border border border-border">
              <div className="bg-card p-8 text-center">
                <Users className="w-6 h-6 text-primary mx-auto mb-3" />
                <div className="font-serif text-4xl" data-testid="referral-count">{data.referrals}</div>
                <div className="text-xs uppercase tracking-widest font-mono text-muted-foreground mt-1">Friends referred</div>
              </div>
              <div className="bg-card p-8 text-center">
                <Check className="w-6 h-6 text-primary mx-auto mb-3" />
                <div className="font-serif text-4xl" data-testid="referral-earned">{data.free_months_earned}</div>
                <div className="text-xs uppercase tracking-widest font-mono text-muted-foreground mt-1">Free months earned</div>
              </div>
            </div>
          </>
        )}
      </div>
    </PageShell>
  );
}
